/**
 * Utility function to extract error messages from API responses
 * Handles both string and array validation error formats
 */
export const extractErrorMessage = (error, defaultMessage = 'An error occurred') => {
  if (!error.response?.data?.detail) {
    return defaultMessage;
  }
  
  const detail = error.response.data.detail;
  
  // Handle array of validation errors (Pydantic format)
  if (Array.isArray(detail)) {
    return detail.map(err => err.msg || 'Validation error').join(', ');
  }
  
  // Handle string error messages
  if (typeof detail === 'string') {
    return detail;
  }
  
  // Handle object error (single validation error)
  if (typeof detail === 'object' && detail.msg) {
    return detail.msg;
  }
  
  return defaultMessage;
};